import React from 'react';
import { Modal } from './styles';

export default props => <Modal {...props} />;